<template>
  <el-tooltip content="Complete this job in task"
    :open-delay="300" placement="top">
    <div v-if="!this.$store.getters.getUserExtraInfo?.hide_generic_task_assignment ?? false">
      <base-button :disabled="!taskInOrder.length" id="btnCompleteTask" class="btn-simple mr-2"
        @click="updateStatus()">
        {{ $t("taskAssignmentGeneric.documents.addDocument.completeTask") }}
      </base-button>
    </div>
  </el-tooltip>
</template>

<script>
import { mapGetters } from "vuex";
import { completeThisJob } from "@/util/utils";
import { Message } from "element-ui";

export default {
  name: 'TaskAssignmentCompleteTask',
  data() {
    return {
      taskOrders: [],
    };
  },
  watch: {
    'order': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getTaskOrder();
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters("taskAssignmentGeneric", ["isLinkATaskEnabled", "getTaskList", "isTaskSelected"]),
    ...mapGetters({
      order: "getOrder",
    }),
    taskInOrder() {
      let taskInOrder = this.taskOrders;
      return taskInOrder.filter(
        (task) => task.order_detail_id === this.order.order_detail_id
      );
    }
  },
  methods: {
    async updateStatus() {
      try {
        let selectedTask = this.taskInOrder[0]?.task_id;
        let status = this.taskInOrder[0]?.review_steps === 3
          ? 'completed'
          : 'in-review';

        this.$preloader.fadeIn();

        await this.$axios.post(`/features/tasks/order/${selectedTask}/status`,
          {
            order_status: status,
            task_id: selectedTask,
            order_detail_id: this.order.order_detail_id,
            approve_date: new Date()
          },
        );

        this.$preloader.fadeOut();

        this.$emit("task-updated");

        Message({
          showClose: true,
          message: 'Job Completed',
          type: 'success',
        });
        window.gtm.create_task({
          tool_name: this.order.slug,
          tool_category: this.order.category,
          order_id: this.order.id,
          order_detail_id: this.order.order_detail_id,
          user_id: this.$store.getters.getUser.id,
          email: this.$store.getters.getUser.email,
          workspace_name: this.$store.getters.selectedWorkspace.name
        });
      } catch (error) {
        console.error(error);
        Message({
          showClose: true,
          message: 'Failed to complete job',
          type: 'error',
        });
      }
    },
    async getTaskOrder() {
      try {
        const response = await this.$axios.get(`/features/tasks/order`, {
        });
        this.taskOrders = response.data;
      } catch (error) {
        console.error('Error fetching task order:', error);
      }
    },
  },
}
</script>
